import React, { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Highlights from "./components/Highlights";
import PriceList from "./components/PriceList";
import Amenities from "./components/Amenities";
import Location from "./components/Location";
import FloorPlans from "./components/FloorPlans";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import EnquiryModal from "./components/EnquiryModal";
import FloatingActions from "./components/FloatingActions";
import { Toaster } from "./components/ui/toaster";

function App() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const openEnquiry = () => setEnquiryOpen(true);

  return (
    <div className="App">
      <Navbar onEnquire={openEnquiry} />
      <Hero onEnquire={openEnquiry} />
      <Overview />
      <Highlights />
      <PriceList onEnquire={openEnquiry} />
      <Amenities />
      <Location />
      <FloorPlans onEnquire={openEnquiry} />
      <Gallery />
      <Contact />
      <Footer />
      <FloatingActions onEnquire={openEnquiry} />
      <EnquiryModal open={enquiryOpen} onOpenChange={setEnquiryOpen} />
      <Toaster />
    </div>
  );
}

export default App;
